import React from "react";
import newyork from "images/newyork.png"
import newyorkflag from "images/newyorkflag.png"
import la from "images/la.png"
import laflag from "images/laflag.png"
import miami from "images/miami.png"
import miamiflag from "images/miamiflag.png"

const locations = [
  { name: "New York", image: newyork, flag: newyorkflag },
  { name: "Washington DC", image: la, flag: laflag },
  { name: "Miami", image: miami, flag: miamiflag },
];

const LocationCard = ({ location }: { location: { name: string; image: any; flag: string } }) => {
  return (
    <div className="relative  rounded-lg overflow-hidden shadow-lg">
      <img src={`${location.image}`} alt={location.name} className="w-full h-full object-cover" />
      <div className="absolute top-2 right-2 w-8 h-8">
        <img src={location.flag} alt="flag" className="w-full h-full rounded-full" />
      </div>
      <div className="absolute bottom-2 left-2 text-white text-lg font-semibold">
        {location.name}
      </div>
    </div>
  );
};

const LocationSection = () => {
  return (
    <div className="flex flex-col items-center p-6">
      <h2 className="text-4xl font-bold text-center">We Are Somewhere Near You</h2>
      <p className="text-gray-600 text-center mb-6">Let's see in how many locations we are here</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {locations.map((location, index) => (
          <LocationCard key={index} location={location} />
        ))}
      </div>
    </div>
  );
};

export default LocationSection;
